import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { toast, ToastContainer } from "react-toastify";
import { useModal } from "./ModalContext";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });
  const { isModalOpen } = useModal();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_x40bhxy",
        "template_test",
        {
          to_name: "Romain KORDALSKI",
          from_name: formData.firstName + " " + formData.lastName,
          from_email: formData.email,
          message: formData.message,
        },
        "IdkEeH4ERWQi7aGiy"
      )
      .then(
        (response) => {
          console.log(
            "Message sent successfully!",
            response.status,
            response.text
          );
          toast.success("Message envoyé avec succès!");
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            message: "",
          });
        },
        (error) => {
          console.error("Failed to send message.", error);
          toast.error("Échec de l'envoi du message. Veuillez réessayer.");
        }
      );
  };

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (isModalOpen) return;

      const contactSection = document.getElementById("contact");
      const windowHeight = window.innerHeight;
      const triggerPosition = windowHeight * 0.8;

      setIsVisible(contactSection.offsetTop < window.scrollY + triggerPosition);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isModalOpen]);

  return (
    <div
      className={`contact-form ${isVisible ? "slideup-anim" : ""}`}
      id="contact"
    >
      <h2 className="title">Contact</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Nom:
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Prénom:
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Email:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Message:
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
        </label>
        <button type="submit">Envoyer message</button>
      </form>
      <ToastContainer />
    </div>
  );
};

export default Contact;
